import gql from "graphql-tag";

const UPDATE_PROSPECT_TRAFFIC = gql`
  mutation updateProspectTraffic($input: ProspectTrafficUpdateInput!) {
    updateProspectTraffic(input: $input) {
      message
      code
    }
  }
`;

export default UPDATE_PROSPECT_TRAFFIC;
